<template>
  <div data-luko-tracking="Page-Perks">
    <PerksPageModule :data="document" />
  </div>
</template>

<script>
import PerksPageModule from '~/modules/PerksPage'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    const { open_graph_title, open_graph_description, open_graph_image } = this.document.body.find((s) => s.slice_type === 'open_graph')?.primary

    const defaultMeta = {
      twitter_title: open_graph_title[0].text,
      twitter_description: open_graph_description[0].text,
      twitter_image: open_graph_image.url,
    }

    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    PerksPageModule,
  },

  async asyncData({ $prismic, store, app, error }) {
    try {
      const { data: document, alternate_languages } = await $prismic.api.getSingle('perks_page', {
        lang: app.i18n.localeProperties.prismicIso,
      })

      store.dispatch('setAlternateLanguages', alternate_languages)
      // Force to set theme for navbar and footer
      store.commit('page/UPDATE', { primary: { theme: '2021Q4-pink' } })

      document.body1 = document.body1.map((slice) => {
        if (slice.slice_type !== 'categories_list') return slice

        slice.items = document.body1
          .map((innerSlice) => {
            if (innerSlice.slice_type !== 'cards_list') return ''
            return innerSlice.primary?.title[0]?.text
          })
          .filter((e) => e)

        return slice
      })

      return {
        document,
        metaDatas: document.body || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
